import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function isOriginBackoffice(){
    return process.env.VUE_APP_ORIGIN_BACKOFFICE && process.env.VUE_APP_ORIGIN_BACKOFFICE === 'true'
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    name: "home",
                    component: () => import('./views/Home.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/user-settings',
                    name: "user-settings",
                    component: () => import('./views/user-settings/UserSettings.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/users',
                    name: "users-list",
                    component: () => import('./views/users/UsersList.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/two-factor',
                    name: 'two-factor',
                    component: () =>
                        import ('./views/users/TwoFactor.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/tenants',
                    name: "tenant-list",
                    component: () => import('./views/Tenants/Tenants.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/tenants/bulk-update-connections',
                    name: "tenant-bulk-update-instances",
                    component: () => import('./views/Tenants/BulkUpdateInstances.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/tenants/nps-feature',
                    name: "tenant-nps-feature",
                    component: () => import('./views/Tenants/NpsFeature.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/tenants/banners',
                    name: "banners-list",
                    component: () => import('./views/Tenants/Banners.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/notification',
                    name: "feature-notification",
                    component: () => import('./views/feature-notification/notifications.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/whatsapp/campaigns',
                    name: 'whatsapp-campaigns',
                    component: () => import('./views/campaigns/MassCampaigns.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/crm/categories',
                    name: 'customer-categories-mass',
                    component: () => import('./views/customer-categories/MassCustomerCategories.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/roles/list',
                    name: "roles-list",
                    component: () => import ('./views/roles/RolesList.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/roles/edit/:id',
                    name: "roles-list-update",
                    component: () => import ('./views/roles/RolesForm.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/analytics',
                    name: 'dashboard-analytics',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/control-panel',
                    name: 'dashboard-control-panel',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/maria-panel',
                    name: 'dashboard-maria-panel',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/maria-analitica-panel',
                    name: 'dashboard-maria-analitica-panel',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/nps-feature-analytics',
                    name: 'dashboard-nps-feature-analytics',
                    component: () => import ('./views/analytics/NpsFeatureAnalytics.vue'),
                    meta: {
                        rule: 'check',
                        permissionRoute: 'tenant-nps-feature'
                    }
                },
                {
                    path: '/dashboard/produtivity-report',
                    name: 'dashboard-produtivity-report',
                    component: () => import ('./views/report/MetabaseReport.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/orders-sales-report',
                    name: 'orders-sales-report',
                    component: () => import('./views/report/OrdersSalesReport.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/report',
                    name: "dashboard-report",
                    component: () => import ('./views/report/Report.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/chat-flows/passive/list',
                    name: 'chat-flows-passive-list',
                    component: () => import('@/views/chat-flows/ChatFlowsList.vue'),
                    props: {
                        type: 'passive'
                    },
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/chat-flows/active/list',
                    name: 'chat-flows-active-list',
                    component: () => import('@/views/chat-flows/ChatFlowsList.vue'),
                    props: {
                        type: 'active'
                    },
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/report-smart',
                    name: "dashboard-report-smart",
                    component: () => import ('./views/report/Report.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/total-attendances-report',
                    name: 'dashboard-total-attendances-report',
                    component: () => import('./views/report/TotalAttendancesReport.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/approvals/pending',
                    name: "approval-list",
                    component: () => import('@/views/approvals/PendingApprovals.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/approvals/my-requests',
                    name: "requests",
                    component: () => import('@/views/approvals/MyRequests.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/approvals/:id',
                    name: "approval-update",
                    component: () => import('@/views/approvals/RequestDetail.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/info/:tenantName',
                    name: "info",
                    component: () => import ('./views/Tenants/TenantInfo.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'login',
                    component: () => import('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'all'
                    }
                },

                {
                    path: '/pages/comingsoon',
                    name: 'page-coming-son',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'all'
                    }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.beforeEach((to, from, next) => {
    const backofficeOnlyRoutes = [
        'approval-list',
        'requests',
        'approval-update',
        'tenant-nps-feature',
        'notifications-center',
        'tenant-bulk-update-instances',
        'banners-list',
        'chat-flows-passive-list',
        'chat-flows-active-list',
        'orders-sales-report',
        'whatsapp-campaigns',
        'customer-categories-mass',
        'dashboard-nps-feature-analytics'
    ];

    let hasPending2FA = localStorage.getItem('twoFactor') === 'true' && !localStorage.getItem('accessToken');
    if (!hasPending2FA) {
        try {
            const u = JSON.parse(localStorage.getItem('userInfo') || '{}')
            if (u.twofactor_activity === true && u.is_two_factor_validated === false) {
                hasPending2FA = true
            }
        } catch (e) {}
    }

    if (!isOriginBackoffice() && backofficeOnlyRoutes.includes(to.name)) {
        return next('/pages/not-authorized');
    }

    if (hasPending2FA && to.name !== 'two-factor' && to.name !== 'login' && to.name !== 'user-settings') {
        return next('/two-factor');
    }

    if (to.meta.rule === 'check') {
        return next()
    }
    return next()
})

export default router;